import {Component, Inject, LOCALE_ID} from '@angular/core';
import {UrlHelperService} from '@app/service/url-helper.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
	readonly language: string;
	readonly basePath: string;

	constructor(@Inject(LOCALE_ID) private locale: string, urlHelper: UrlHelperService) {
		this.language = locale.substring(0, 2).toLowerCase();
		this.basePath = urlHelper.getNonLocalizedBasePath();
	}

	currentYear(): number {
		return new Date().getFullYear();
	}
}
